/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
requirejs.config({
	paths: {
		'ol': 'lib/ol/ol'
	}
});

define(["ol",
	"hvx/modules/CoreModule", "./map/MapController", "./map/MapViewer", "./map/MapStyle",
	"./map/ClickListener", "./map/DefaultDetailRenderer",
	"./map/HoverListener", "./map/DefaultHoverRenderer"],
	function(ol, Core, MapController, MapViewer, MapStyle,
			ClickListener, DefaultDetailRenderer,
			HoverListener, DefaultHoverRenderer) {
		
		var MapModule = function(){};
		
		MapModule.prototype.load = function(options){
			var containerComponent = Core.View.getMainContentComponent();
		
			//Add Map module to main content component
			var mapView = new MapViewer();
			mapView.setMap(containerComponent, -7915207.15, 5211170.84, 7);
	
			this.mapStyle = new MapStyle();
			this.mapController = new MapController(mapView, this.mapStyle);
			this.mapController.bindEvents();
			
			//TODO: refactor away from this
			Core.Ext = Core.Ext || {};
			Core.Ext.Map = this.mapController;
			
			if (!(options && options.clickListener === false)) {
				this.clickListener = new ClickListener([]);
			}
			
			if (!(options && options.hoverListener === false)) {
				this.hoverListener = new HoverListener([new DefaultHoverRenderer()]);
			}
			
			return this.mapController;
		};
		
		MapModule.prototype.getMapController = function(){
			return this.mapController;
		};
		
		MapModule.prototype.getMapStyle = function(){
			return this.mapStyle;
		};
		
		MapModule.prototype.getClickListener = function(){
			return this.clickListener;
		};
		
		MapModule.prototype.getHoverListener = function(){
			return this.hoverListener;
		};
		
		MapModule.prototype.getMap = function(){
			return this.mapController.getMap();
		};

		MapModule.prototype.getOl = function(){
			return ol;
		};
		
		return new MapModule();
	}
);
	
